import { Storage } from 'aws-amplify'

export async function s3Upload (file) {
  const filename = `${Date.now()}-${file.name}`

  const stored = await Storage.vault.put(filename, file, {
    contentType: file.type
  })

  const fileUrl = await Storage.vault.get(stored.key)
  const s3InputUrl = fileUrl.split('?')[0]

  return {
    s3Key: stored.key,
    s3InputUrl
  }
}

export async function s3Get (key) {
  return await Storage.vault.get(key)
}

export async function s3Delete (key) {
  return await Storage.vault.remove(key)
}

// https://docs.aws.amazon.com/sdk-for-javascript/v2/developer-guide/s3-example-photo-album.html#s3-example-photo-album-create-album

// export async function s3Upload (file) {
//   console.log('Upload to S3', file)

//   // const options = Amplify.Storage._options
//   // const { bucket, region, credentials } = options

//   // console.log('OPTIONS', options)
//   // console.log('AMPLIFY', Amplify)
//   // Amplify.Auth
//   //   .currentUserCredentials()
//   //   .then(creds => console.log('credentials', creds))

//   const filename = `${Date.now()}-${file.name}`

//   const stored = await Amplify.Storage.vault.put(filename, file, {
//     contentType: file.type
//   })

//   return stored.key

//   // AWS.config.update({
//   //   region,
//   //   credentials
//   // })

//   // var s3 = new AWS.S3({
//   //   apiVersion: '2006-03-01',
//   //   params: { Bucket: bucket },
//   //   region
//   // })

//   // console.log(Amplify.Storage._options)

//   // const filename = `${Date.now()}-${file.name}`

//   // s3.upload(
//   //   {
//   //     Key: filename,
//   //     Body: file
//   //     // ACL: 'public-read'
//   //   },
//   //   function (err, data) {
//   //     if (err) {
//   //       return alert('There was an error uploading your photo: ', err.message)
//   //     }
//   //     alert('Successfully uploaded')
//   //   }
//   // )

//   // const filename = `${Date.now()}-${file.name}`

//   // const stored = await Storage.vault.put(filename, file, {
//   //   contentType: file.type
//   // })

//   // return stored.key
// }



// WEBPACK FOOTER //
// ./src/libs/awsLib.js